import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { SnackbarProvider } from 'notistack';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { theme } from '@/app/theme';
import { LegalUpdateBanner, PaymentOverdueBanner } from '@/entities/session';
import { Loader } from '@/shared/ui';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';

export function Baseline() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SnackbarProvider
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <div
          style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}
        >
          <LegalUpdateBanner />
          <PaymentOverdueBanner />
          <Suspense fallback={<Loader active />}>
            <Outlet />
          </Suspense>
        </div>
      </SnackbarProvider>
    </ThemeProvider>
  );
}
